import React, { useCallback, useMemo } from "react";
import Cookies from "js-cookie";

import HlsVideoPlayer from "./HlsVideoPlayer";
import { VideoPlayerContainer } from "./VideoPlayer.styles";

const BASE_URL = process.env.REACT_APP_BASE_URL || "/api/v1";

interface VideoPlayerProps {
  lessonId: number;
  videoId: number;
  courseId: number;
  videoName?: string;
  onVideoRef?: (ref: HTMLVideoElement | null) => void;
  onPlay?: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  lessonId,
  videoId,
  courseId: _courseId,
  videoName,
  onVideoRef,
  onPlay,
}) => {
  const accessToken = Cookies.get("access_token");
  const requestHeaders = useMemo(
    () => (accessToken ? { Authorization: "Bearer " + accessToken } : undefined),
    [accessToken],
  );

  const baseUrl = BASE_URL.endsWith("/") ? BASE_URL.slice(0, -1) : BASE_URL;
  const playlistUrl =
    baseUrl + "/videos/lesson/" + lessonId + "/video/" + videoId + "/hls/playlist.m3u8";
  const watchedUrl =
    baseUrl + "/videos/lesson/" + lessonId + "/video/" + videoId + "/watched/";
  const reportWatchThreshold = useCallback(() => {
    if (!requestHeaders) return;
    void fetch(watchedUrl, {
      method: "POST",
      headers: requestHeaders,
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) {
          console.warn("Не удалось зафиксировать просмотр видео", response.status);
        }
      })
      .catch((error) => console.warn("Ошибка фиксации просмотра видео", error));
  }, [requestHeaders, watchedUrl]);

  if (!accessToken || !requestHeaders) {
    return (
      <VideoPlayerContainer>
        <div style={{ padding: 16, color: "#fff", textAlign: "center" }}>
          Токен авторизации отсутствует
        </div>
      </VideoPlayerContainer>
    );
  }

  return (
    <HlsVideoPlayer
      playlistUrl={playlistUrl}
      videoName={videoName}
      requestHeaders={requestHeaders}
      onVideoRef={onVideoRef}
      onPlay={onPlay}
      onWatchThresholdReached={reportWatchThreshold}
    />
  );
};

export default VideoPlayer;